export class AnalyticsManager {
    constructor(config) {
        this.providers = [];
        this.globalContext = {};
        this.config = config;
    }
    static setInstance(instance) {
        this.instance = instance;
    }
    static getInstance() {
        if (!this.instance) {
            throw new Error("[Analytics] AnalyticsManager not initialized. Call setInstance() first.");
        }
        return this.instance;
    }
    registerProvider(provider) {
        this.providers.push(provider);
        if (this.config.debugMode) {
            console.log(`[Analytics] Registered provider: ${provider.name}`);
        }
    }
    setGlobalProperties(properties) {
        this.globalContext = { ...this.globalContext, ...properties };
        if (this.config.debugMode) {
            console.log("[Analytics] Global properties updated:", this.globalContext);
        }
    }
    track(eventName, version, payload) {
        if (!this.config.isEnabled && !this.config.debugMode)
            return;
        const finalPayload = {
            ...this.globalContext,
            ...payload,
            event_version: version,
            timestamp: new Date().toISOString(),
        };
        if (this.config.debugMode) {
            console.group(`[Analytics] ${this.config.isEnabled ? "" : "[DRY RUN] "}Event: ${eventName} (v${version})`);
            console.log("Payload:", finalPayload);
            console.groupEnd();
        }
        if (!this.config.isEnabled)
            return;
        this.providers.forEach((provider) => {
            try {
                provider.trackEvent(eventName, finalPayload);
            }
            catch (error) {
                console.error(`[Analytics] Provider ${provider.name} failed to track event ${eventName}:`, error);
            }
        });
    }
    identify(userId, traits) {
        if (!this.config.isEnabled)
            return;
        if (this.config.debugMode) {
            console.log(`[Analytics] Identifying user: ${userId}`, traits);
        }
        this.providers.forEach((provider) => provider.identifyUser(userId, traits));
    }
    setUserProperties(properties) {
        if (!this.config.isEnabled)
            return;
        if (this.config.debugMode) {
            console.log("[Analytics] Setting user properties:", properties);
        }
        this.providers.forEach((provider) => provider.setUserProperties(properties));
    }
    screen(screenName, properties) {
        if (!this.config.isEnabled)
            return;
        const finalProperties = { ...this.globalContext, ...properties };
        if (this.config.debugMode) {
            console.log(`[Analytics] Screen View: ${screenName}`, finalProperties);
        }
        this.providers.forEach((provider) => provider.trackScreen(screenName, finalProperties));
    }
    resetUser() {
        if (!this.config.isEnabled)
            return;
        if (this.config.debugMode) {
            console.log("[Analytics] resetUser");
        }
        this.providers.forEach((provider) => {
            try {
                provider.resetUser();
            }
            catch (error) {
                console.error(`[Analytics] Provider ${provider.name} failed resetUser:`, error);
            }
        });
    }
}
